import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { 
    brandFetch,
    brandFetchPromo
} from '../redux/actions'

class Productbrand extends Component {

    constructor() {
        super()
        this.state = {
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        this.props.brandFetch()
        this.props.brandFetchPromo()
    }

    showBrands() {
        if(this.props.brands) {
            return this.props.brands.map((item, index) => {
                if (!item.type_stand) {
                    item.type_stand = 0
                }
                if (!item.type_one_way) {
                    item.type_one_way = 0
                }
                return (
                    <div className="each-brand" key={++index}>
                        <Analytics />
                        <Link to={{ pathname:"/producttype", search:"?title="+item.title+"&type_wall="+item.type_wall+"&type_hang="+item.type_hang+"&type_four="+item.type_four+"&type_concealed="+item.type_concealed+"&type_stand="+item.type_stand+"&type_one_way="+item.type_one_way }}>
                            <img src={item.img} alt={item.title}/>
                        </Link>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() {
        if(!this.state.isLogin) return <div></div>
        else {
            let promoImg = { url: '' }
            if (this.props.promoImg.length > 0) {
                promoImg = this.props.promoImg.filter(item => item.rank === parseInt(this.state.user.rank))[0]
            }
            return ( 
                <div className="page-productbrand">
                    <div className="productbrand-header">
                        <Backbtn />
                        <div className="title">
                            <p>เลือกแบรนด์</p>
                        </div>
                        <Nav />
                    </div>
                    <div className="productbrand-banner container">
                        {/* {(this.props.promoImg && <a href={this.props.promoUrl}>
                            <img src={this.props.promoImg} alt="โปรโมชั่นแอร์"/>
                        </a>)} */}
                        <img src={promoImg.url} alt="โปรโมชั่นแอร์"/>
                    </div>
                    <div className="productbrand-brand container">
                        {this.showBrands()}
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
 
const mapStateToProps = ({ brand }) => {
    return { 
        brands: brand.brands,
        promoImg: brand.promoBrand || [],
        // promoUrl: brand.promoBrand[1] || ''
    }
}
 
export default connect(mapStateToProps, { 
    brandFetch, brandFetchPromo
})(Productbrand)